import Localization, { TrustedValue } from 'lib/localization';

export default {
  get lxPageIndexHeroBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.hero.block.title');
  },

  get lxPageIndexHeroBlockSubTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.date.one.block.text');
  },

  get lxPageIndexHeroBlockAction() {
    return Localization.get('bumblesite@rebrand.2024.page.date.one.block.cta-action');
  },

  get lxPageIndexOneBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.one.block.title');
  },

  get lxPageIndexOneBlockText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.one.block.text');
  },

  get lxPageIndexOneBlockAction() {
    return Localization.get('bumblesite@rebrand.2024.page.index.one.block.action');
  },

  get lxPageIndexTwoBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.title');
  },

  get lxPageIndexTwoBlockOneItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.one.title');
  },

  get lxPageIndexTwoBlockOneItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.one.text');
  },

  get lxPageIndexTwoBlockTwoItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.two.title');
  },

  get lxPageIndexTwoBlockTwoItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.two.text');
  },

  get lxPageIndexTwoBlockThreeItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.three.title');
  },

  get lxPageIndexTwoBlockThreeItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.two.block.item.three.text');
  },

  get lxPageIndexThreeBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.three.block.title');
  },

  get lxPageIndexThreeBlockText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.three.block.text');
  },

  get lxPageIndexThreeBlockAction() {
    return Localization.get('bumblesite@rebrand.2024.page.index.three.block.action');
  },

  get lxPageIndexFourBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.title');
  },

  get lxPageIndexFourBlockOneItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.one.title');
  },

  get lxPageIndexFourBlockOneItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.one.text');
  },

  get lxPageIndexFourBlockTwoItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.two.title');
  },

  get lxPageIndexFourBlockTwoItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.two.text');
  },

  get lxPageIndexFourBlockThreeItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.three.title');
  },

  get lxPageIndexFourBlockThreeItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.index.four.block.item.three.text');
  },

  /* Project Love start */
  get lxPageIndexCarouselStackedTitle() {
    return Localization.get('bumblesite@page.index.carousel.stacked.title');
  },

  get lxPageIndexCarouselStackedDescription() {
    return Localization.get('bumblesite@page.index.carousel.stacked.description');
  },

  get lxPageIndexCarouselStackedCta() {
    return Localization.get('bumblesite@page.index.carousel.stacked.cta');
  },

  get lxPageIndexCarouselStackedCard1Badge() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card1.badge');
  },

  get lxPageIndexCarouselStackedCard1Alt() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card1.alt');
  },

  get lxPageIndexCarouselStackedCard2Badge() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card2.badge');
  },

  get lxPageIndexCarouselStackedCard2Alt() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card2.alt');
  },

  get lxPageIndexCarouselStackedCard3Badge() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card3.badge');
  },

  get lxPageIndexCarouselStackedCard3Alt() {
    return Localization.get('bumblesite@page.index.carousel.stacked.card3.alt');
  },

  get lxPageIndex2CardsBumbleTitle() {
    return Localization.get('bumblesite@footer.apps.bumble_date');
  },

  get lxPageIndex2CardsBumbleDescription() {
    return Localization.get('bumblesite@page.index.2_cards.bumble.description');
  },

  get lxPageIndex2CardsBumbleAlt() {
    return Localization.get('bumblesite@page.index.2_cards.bumble.alt');
  },

  get lxPageIndex2CardsBumbleLink() {
    return Localization.get('bumblesite@page.index.2_cards.bumble.link');
  },

  get lxPageIndex2CardsBFFDescription() {
    return Localization.get('bumblesite@page.index.2_cards.bff.description', { bff: 'BFF' });
  },

  get lxPageIndex2CardsBFFAlt() {
    return Localization.get('bumblesite@page.index.2_cards.bff.alt');
  },

  get lxPageIndex2CardsBFFLink() {
    return Localization.get('bumblesite@page.index.2_cards.bff.link');
  },

  get lxPageIndexMeetInPersonTitle() {
    return Localization.get('bumblesite@page.index.meet_in_person.title');
  },

  get lxPageIndexMeetInPersonDescription() {
    return Localization.get('bumblesite@page.index.meet_in_person.description');
  },

  get lxPageIndexMeetInPersonAlt() {
    return Localization.get('bumblesite@page.index.meet_in_person.alt');
  },

  get lxPageIndexMeetInPersonCta() {
    return Localization.get('bumblesite@page.index.meet_in_person.cta');
  },

  get lxPageIndexLoveStoriesQuote() {
    return Localization.get('bumblesite@page.index.love_stories.quote', {
      __EOL__: TrustedValue.for('<br/>'),
    });
  },

  lxPageIndexLoveStoriesAuthor(name1: string, name2: string, numYears: number) {
    return Localization.get('bumblesite@page.index.love_stories.author', {
      name1,
      name2,
      num: numYears,
    });
  },

  get lxPageIndexLoveStoriesCtaButton() {
    return Localization.get('bumblesite@page.index.love_stories.cta.text');
  },

  get lxPageIndexLoveStoriesCtaLink() {
    return Localization.get('bumblesite@page.index.love_stories.cta');
  },

  get lxPageIndexLoveStoriesAlt() {
    return Localization.get('bumblesite@page.index.love_stories.alt');
  },

  get lxPageIndexHeroCard1Alt() {
    return Localization.get('bumblesite@page.index.hero.card1.alt');
  },

  get lxPageIndexHeroCard2Alt() {
    return Localization.get('bumblesite@page.index.hero.card2.alt');
  },

  get lxPageIndexHeroCard3Alt() {
    return Localization.get('bumblesite@page.index.hero.card3.alt');
  },

  get lxPageIndexSubscribeTitle() {
    return Localization.get('bumblesite@page.index.subscribe.title2');
  },

  get lxPageIndexSubscribeDescription() {
    return Localization.get('bumblesite@page.index.subscribe.description2', {
      __EOL__: TrustedValue.for('<br/>'),
    });
  },

  get lxPageIndexSubscribeCta() {
    return Localization.get('bumblesite@page.index.subscribe.cta2');
  },

  get lxPageIndexSubscribeAlt() {
    return Localization.get('bumblesite@page.index.subscribe.alt');
  },

  /* Project Love end */
};
